// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Status of object processing during the job session.
 * @export
 * @enum {string}
 */
export enum RESTJobSessionObjectStatus {
    Success = 'Success',
    Warning = 'Warning',
    Failed = 'Failed'
}

